import { render, staticRenderFns } from "./c-speaker.vue?vue&type=template&id=4a1f93d0&scoped=true"
import script from "./c-speaker.vue?vue&type=script&lang=js"
export * from "./c-speaker.vue?vue&type=script&lang=js"
import style0 from "./c-speaker.vue?vue&type=style&index=0&id=4a1f93d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f93d0",
  null
  
)

export default component.exports